import { PropsWithChildren } from "react";
import { ApolloProvider } from "@apollo/client";

import { client } from "../../client";
import { ModalProvider } from "../../contexts";

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <ApolloProvider client={client}>
      <ModalProvider>{children}</ModalProvider>
    </ApolloProvider>
  );
};
